///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq = abcsetup.rfq || {};
abcsetup.rfq.comments = abcsetup.rfq.comments || {};




///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.comments.rfq_bid_request_id = null;
abcsetup.rfq.comments.org_id = null;



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rfq.comments = {
    init: function () {
        $('a.rfq.comments').bind('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            abcsetup.rfq.comments.rfq_bid_request_id = $(this).data('id');
            abcsetup.rfq.comments.loadComments($(this));
            return false;
        });

        // View RFQ Comments clicked
        $(document).on('click', 'a.rfq.comments', function() {
            abcsetup.rfq.comments.rfq_bid_request_id = $(this).data('id');
            abcsetup.rfq.comments.loadComments($(this));
            return false;
        });

        // The RFQ comments modal has been shown
        $(document).on('shown.bs.modal', '#rfq-comments-modal', function() {
            // Auto scroll to the bottom - for some reason start: 'bottom' doesn't always work on dyanmic modals
            $('#rfq-comments-modal .modal-body .chat').slimScroll({
                alwaysVisible: true,
                scrollTo: $('#rfq-comments-modal .modal-body .chat')[0].scrollHeight,
            });

            // Focus on the message field
            $('#rfq-comments-modal #message').focus();
        });

        // The message field had a key pressed
        /*
        $(document).on('keyup', '#rfq-comments-modal #message', function(e) {
            // Enter key is pressed and we have a value
            if (e.which == 13 && $(this).val()) {
                e.preventDefault();
                $('#rfq-comments-modal .btn-primary').trigger('click');
                return false;
            }
        });
        */

        // Send button clicked
        $(document).on('click', '#rfq-comments-modal .btn-primary', function() {
            // Dont send blank messages
            if ($('#rfq-comments-modal #message').val() == '') {
                return false;
            }

            // Update the message field and send button's cursor + state
            $('#rfq-comments-modal #message').css("cursor", "progress").attr('disabled', true);
            $(this).css("cursor", "progress").attr('disabled', true);

            axios.post('/api/rfq/comments', { rfq_bid_request_id: abcsetup.rfq.comments.rfq_bid_request_id, org_id: abcsetup.rfq.comments.org_id, message: $('#rfq-comments-modal #message').val()}).then(response => {
                // Update the message field and send button's cursor + state
                $('#rfq-comments-modal #message').css("cursor", "text").attr('disabled', false);
                $(this).css("cursor", "pointer").attr('disabled', false);

                // Remove the no messages alert
                $('#rfq-comments-modal .no-messages').remove();

                // Append the new comment
                let link = $('#rfq-comments-modal .suppliers .list-group-item.active');
                abcsetup.rfq.comments.loadComments(link, true);

                $('#rfq-comments-modal #message').val('');
            });
        });

        // Supplier list group clicked
        $(document).on('click', '#rfq-comments-modal div.suppliers a', function() {
            abcsetup.rfq.comments.loadComments($(this), true);
            $('#rfq-comments-modal .suppliers .list-group-item.active').removeClass('active');
            $(this).addClass('active').find('.badge').remove();
            return false;
        });

        // Approve extension button clicked
        $(document).on('click', '#rfq-comments-modal .btn-extension-approve', function() {
            abcsetup.rfq.comments.approveExtension($(this));
        });

        // Ignore extension button clicked
        $(document).on('click', '#rfq-comments-modal .btn-extension-ignore', function() {
            abcsetup.rfq.comments.ignoreExtension($(this));
        });

        // The supplier search field had a key pressed
        $(document).on('keyup', '#rfq-comments-modal .supplier-search', function() {
            var value = $(this).val().toLowerCase();

            if (value) {
                // Filter down the sections + links to what was typed
                $("#rfq-comments-modal div.suppliers a").filter(function() {
                    $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
                });

            } else {
                // Clear search results and show all links
                $("#rfq-comments-modal div.suppliers a").show();
            }
        });
    },

    /**
     * Load the comments for the specified link
     */
    loadComments: function(link, updateView = false) {
        var height = $(window).height() * .5; // Make the scrollable area 50% of the available screen
        link.css("cursor", "progress");

        abcsetup.rfq.comments.org_id = link.data('org-id') || '';

        // Remove the unread class from all the chat links for the rfq_bid_request_id
        $('a[data-id="' + abcsetup.rfq.comments.rfq_bid_request_id + '"]').removeClass('text-danger');

        // Load the comments
        axios.get('/api/rfq/comments?rfq_bid_request_id=' + abcsetup.rfq.comments.rfq_bid_request_id + '&org_id=' + abcsetup.rfq.comments.org_id).then(response => {
            //alert(JSON.stringify(response.data));

            link.css("cursor", "pointer");

            // We're not updating the modal view
            if (!updateView) {
                // Remove any existing comments modal
                $('#rfq-comments-modal').remove();

                $('body').append(response.data);
                $('#rfq-comments-modal').modal('show');

            } else {
                $('#rfq-comments-modal .chat').html($(response.data).find('.chat').html());
                $('#rfq-comments-modal .modal-footer .hide').show();
            }

            // Apply slim scroll
            $('#rfq-comments-modal .modal-body .chat').slimScroll({
                height: height + 'px',
                railVisible: true,
                alwaysVisible: true,
                start: 'bottom'
            });

            // Apply slim scroll to the suppliers list
            $('#rfq-comments-modal .modal-body .suppliers').slimScroll({
                height: height + 'px',
                railVisible: true,
                alwaysVisible: true,
                wheelStep : 1,
                touchScrollStep : 5,
            });

            // Auto scroll to the bottom
            $('#rfq-comments-modal .modal-body .chat').slimScroll({
                alwaysVisible: true,
                scrollTo: $('#rfq-comments-modal .modal-body .chat')[0].scrollHeight,
            });
        });
    },

    /**
     * Approve the specified extension request
     *
     * @param {*} btn
     */
    approveExtension: function(btn) {
        btn.css("cursor", "progress");

        // Ignore the extension
        axios.post('/api/rfq/bid_requests/extend', {id: btn.data('id'), approve: true}).then(response => {
            btn.closest('.btn-group').remove();
        });
    },

    /**
     * Ignore the specified extension request
     *
     * @param {*} btn
     */
    ignoreExtension: function(btn) {
        btn.css("cursor", "progress");

        // Ignore the extension
        axios.post('/api/rfq/bid_requests/extend', {id: btn.data('id'), approve: false}).then(response => {
            btn.closest('.btn-group').remove();
        });
    },
}
